/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
import { FaIcon, SectionHeader, ThemeTokens } from '@acp/core-ui';
import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    HStack,
    IconButton,
    Menu,
    Spacer,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import {
    faBars,
    faBuilding,
    faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { useAgencySwitcher, useLogout, useSession } from '@acp/feature/auth';
import {
    NotificationButton,
} from '../../../features/notifications';
import { DiLogo } from '../../di-logo';
import { MobileNavigationRender } from '../menu-render';
import { NavBarContainer } from '../nav-bar-container';
import { SwitchPortfolioPanel } from '../switch-portfolio-panel';
import { MobileNavigationItem } from './mobile-navigation-item';
import { AppNavigationItem } from '../types';

export function MobileNavigation({ navItems }: { navItems: AppNavigationItem[] }) {
    const mobileMenuDisclosure = useDisclosure();
    const switchPortfolioDisclosure = useDisclosure();
    const {
        complianceUserName,
        complianceAgencyName,
        isImpersonating,
        complianceSystemUrl,
    } = useSession();
    const { handleLogout } = useLogout();

    const handleOpenMobileNav = () => {
        mobileMenuDisclosure.onOpen();
        switchPortfolioDisclosure.onClose();
    };

    // eslint-disable-next-line operator-linebreak
    const { userAgencies, isLoading } = useAgencySwitcher();

    // eslint-disable-next-line operator-linebreak
    const hasUserAgencies =
        !isLoading && userAgencies !== undefined && userAgencies.length > 0;

    return (
        <NavBarContainer>
            <HStack justifyContent="center" w="full" bg="white">
                <IconButton
                    onClick={handleOpenMobileNav}
                    variant="ghost"
                    colorScheme="muted"
                    aria-label="menu"
                    icon={<FaIcon icon={faBars} />}
                    position="absolute"
                    left={3}
                    size="sm"
                    color="muted.500"
                />

                <DiLogo variant="horizontalRGB" w="10rem" />
            </HStack>

            <Drawer
                placement="left"
                isOpen={mobileMenuDisclosure.isOpen}
                onClose={mobileMenuDisclosure.onClose}
                size="full"
            >
                <DrawerOverlay />
                <DrawerContent bg={ThemeTokens.Defaults.bgColor} overflowY="auto">
                    {/* DI logo, close btn */}
                    <DrawerHeader
                        bg="white"
                        borderBottomWidth={1}
                        px={ThemeTokens.Defaults.px}
                        py={5}
                    >
                        <HStack justifyContent="center">
                            <IconButton
                                onClick={mobileMenuDisclosure.onClose}
                                variant="ghost"
                                colorScheme="muted"
                                aria-label="menu"
                                icon={<FaIcon icon={faXmark} />}
                                position="absolute"
                                left={3}
                                size="sm"
                                color="muted.500"
                            />
                            <DiLogo variant="horizontalRGB" w="10rem" />
                        </HStack>
                    </DrawerHeader>

                    {/* user profile */}
                    <Box
                        px={ThemeTokens.Defaults.px}
                        py={ThemeTokens.Defaults.py}
                        borderBottomWidth={1}
                    >
                        <SectionHeader>
                            <HStack>
                                <Text noOfLines={1} maxW="24rem">
                                    Hi, {complianceUserName}
                                </Text>
                                <Spacer />
                                <NotificationButton />
                            </HStack>
                        </SectionHeader>

                        <HStack mt={4}>
                            <Flex>
                                <Box pr={3}>
                                    <FaIcon icon={faBuilding} />
                                </Box>

                                <Box>
                                    <Text size="sm">{complianceAgencyName}</Text>
                                    {/* switch portfolio btn */}
                                    {hasUserAgencies ? (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            fontWeight={300}
                                            color="muted.500"
                                            _hover={{ textDecoration: 'none' }}
                                            onClick={switchPortfolioDisclosure.onOpen}
                                        >
                                            Switch Portfolio
                                        </Button>
                                    ) : null}
                                </Box>
                            </Flex>
                        </HStack>
                    </Box>

                    <DrawerBody px={0} py={0} overflow="unset">
                        <Menu>
                            {/* render mobile navigation items */}
                            {navItems.map((navItem, index) => (
                                <MobileNavigationRender key={index} menuItem={navItem} />
                            ))}
                            {
                                isImpersonating && (
                                    <MobileNavigationItem
                                        label="Switch back"
                                        onClick={() => handleLogout(`${complianceSystemUrl}/App/switchBackToOriginalUser`)}
                                    />
                                )
                            }
                            <MobileNavigationItem label="Sign out" onClick={() => handleLogout()} />
                        </Menu>

                        {/* switch portfolio panel */}
                        <SwitchPortfolioPanel.Mobile
                            isOpen={switchPortfolioDisclosure.isOpen}
                            onClose={switchPortfolioDisclosure.onClose}
                        />

                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </NavBarContainer>
    );
}
